import React from 'react';

import CorteVendedor from './../Dashboard/CorteVendedor';
class Reloj extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			date : new Date(),
			fecha: null
		}
	}
	componentDidMount(){
		this.timerID = setInterval(()=> this.tick(), 1000);

	}
	componentWillUnmount(){
		clearInterval(this.timerID);
	}
	tick(){ 
		this.setState({ 
			date : new Date() 
		}); 
	}
	render(){
		return(<>
			Hora: <strong> <span>{this.state.date.toLocaleTimeString()}</span></strong>
			</>)
	}
}
class Header extends React.Component{
	
	resetCaja = () => {
		window.location.reload();
	}

	render(){
		let sesion = JSON.parse( localStorage.getItem('sesion') );
		return(
			<header className="header">
				<div className="xs-12 sm-4 md-4 lg-4">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					{ ( sesion.rol !== 1 && sesion.rol !== 3 )&&  <strong style={{letterSpacing : '0.4px'}}>Sucursal {sesion.sucursal_name} | </strong> }

					{sesion.rol === 3  &&  <strong style={{cursor:'pointer',color:'#769d28', textDecoration:'underline',letterSpacing : '0.4px'}}>{sesion.name}</strong> }

					{sesion.rol === 1 &&  <strong style={{cursor:'pointer',color:'#769d28', textDecoration:'underline',letterSpacing : '0.4px'}}>{sesion.name}</strong> }
					{sesion.rol === 2 &&  <strong onClick={this.resetCaja} style={{cursor:'pointer',color:'#769d28', textDecoration:'underline',letterSpacing : '0.4px'}}> Actualizar Caja</strong> }
				</div>
				{sesion.rol === 2 &&<CorteVendedor sesion={sesion}/>}
				<div className="xs-12 sm-3 md-3 lg-3 text-right">
					<Reloj />
				</div>
				<br/>
			</header>
		)
	}
}
export default Header;